const OrdersIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      width="512"
      height="512"
      fill="none"
      viewBox="0 0 512 512"
      aria-hidden="true"
    >
      <path
        fill="#000"
        d="M434.709 203.115h-68.138L269.653 70.933A17.1 17.1 0 00256 64a16.702 16.702 0 00-13.589 6.933l-96.939 132.182H77.376a34.25 34.25 0 00-24.49 10.282c-6.507 6.614-10.177 15.574-10.22 24.96 0 3.328.449 6.614 1.387 9.792l49.195 177.302c3.2 11.562 10.005 21.738 19.371 28.97 9.386 7.254 20.8 11.158 32.554 11.158h221.739a53.672 53.672 0 0032.533-11.2c9.387-7.211 16.235-17.344 19.542-28.864l49.28-177.558c.213-.832.362-1.685.469-2.56l.555-5.376a36.12 36.12 0 00-9.558-26.026 33.96 33.96 0 00-25.002-10.923l-.022.043zm-178.645-92.758l67.989 92.736H188.032l67.989-92.757h.043v.021zm0 266.283a39.421 39.421 0 01-22.208-6.976 40.783 40.783 0 01-14.677-18.411 41.79 41.79 0 018.768-44.586c5.61-5.696 12.757-9.6 20.501-11.158a39.254 39.254 0 0123.125 2.347c7.318 3.115 13.568 8.363 17.963 15.083 4.395 6.72 6.741 14.634 6.741 22.72-.064 10.88-4.33 21.29-11.861 28.949-7.552 7.68-17.749 11.989-28.373 11.989v.043h.021z"
      ></path>
    </svg>
  );
};

export default OrdersIcon;
